import type { FC, SVGProps } from 'react';

export const VapiLogo: FC<SVGProps<SVGSVGElement>> = ({
  width = 28,
  height = 28,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 45 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.70679 0.304638C3.21148 -0.425672 5.02331 0.202092 5.75362 1.70679L7.87228 6.07197L10.0253 1.69294C10.7632 0.191979 12.5782 -0.426556 14.0792 0.311402C15.5801 1.04936 16.1987 2.86436 15.4607 4.36532L10.5725 14.3077C10.0619 15.3462 9.0042 16.0029 7.84702 16C6.68985 15.997 5.63551 15.3349 5.13024 14.2939L0.304638 4.35147C-0.425672 2.84678 0.202092 1.03495 1.70679 0.304638ZM23.353 0.000699425C24.5102 0.00364403 25.5645 0.66575 26.0698 1.70679L30.8954 11.6492C31.3509 12.5878 31.2913 13.6947 30.7376 14.5789C30.1839 15.463 29.2141 16 28.1709 16H18.457C17.4111 16 16.4391 15.4602 15.8862 14.5723C15.3334 13.6844 15.2778 12.574 15.7393 11.6354L20.6276 1.69294C21.1381 0.654487 22.1958 -0.00224496 23.353 0.000699425Z"
      fill="currentColor"
    />
  </svg>
);
